var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vx-card__header row" }, [
    _vm._m(0),
    _c(
      "div",
      {
        directives: [
          {
            name: "has-permission",
            rawName: "v-has-permission",
            value: "FEB99",
            expression: "'FEB99'"
          }
        ],
        staticClass: "col-12 col-md-2"
      },
      [
        _c(
          "select",
          {
            staticClass: "form-control",
            attrs: { type: "select" },
            domProps: { value: _vm.application },
            on: {
              change: function($event) {
                return _vm.$emit("update:application", $event.target.value)
              }
            }
          },
          _vm._l(_vm.applications, function(app) {
            return _c("option", { key: app.id, domProps: { value: app.id } }, [
              _vm._v(" " + _vm._s(app.description) + " ")
            ])
          }),
          0
        )
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "has-permission",
            rawName: "v-has-permission",
            value: "FEB99",
            expression: "'FEB99'"
          }
        ],
        staticClass: "col-12 col-md-4"
      },
      [
        _c("ListUser", {
          attrs: {
            id: "user",
            name: "user",
            label: "",
            placeholder: "Seleccione un usuario...",
            value: _vm.selectedUserId
          },
          on: {
            input: function($event) {
              return _vm.$emit("update:selectedUserId", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 col-md-6" }, [
      _c("h4", { staticClass: "text-primary" }, [_vm._v("Parámetros")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }